import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { b as DropdownItemGroupDisplayName } from '../displayNames-CI4WGOeZ.js';
import { w as withTaktFallbackId } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { S as SelectOptionGroup } from '../../SelectList/SelectOptionGroup/SelectOptionGroup-DpxaosSo.js';

const DropdownItemSelectOptionGroup = withTaktFallbackId(SelectOptionGroup);
const DropdownItemGroup = ({
  label,
  children,
  onClick,
  ...restProps
}) => {
  const taktFallbackId = createStormTaktId('dropdown-item-group');
  return /*#__PURE__*/React__default.createElement(DropdownItemSelectOptionGroup, _extends({
    taktFallbackId: taktFallbackId
  }, restProps, {
    label: label,
    onClick: onClick
  }), children);
};
DropdownItemGroup.displayName = DropdownItemGroupDisplayName;

export { DropdownItemGroup as D };
//# sourceMappingURL=DropdownItemGroup-CHhkxO5m.js.map
